const SHOW_LOADING = 'SHOW_LOADING';
const HIDE_LOADING = 'HIDE_LOADING';

const showLoader = () => ({
  type: SHOW_LOADING,
});

const hideLoader = () => ({
  type: HIDE_LOADING,
});

export { SHOW_LOADING, HIDE_LOADING, showLoader, hideLoader };
